export default function FormHeader({ name,color='#ffaf00' }) {


    return (
        <>
            <span className="mb-0 titleBorder">
                {name}
            </span>
            <div className="line"></div>
        </>
    );
}
